import React from "react";
export const AuthContext = React.createContext({
  auth: {
    hubId: "",
    passData: "",
  },
  setAuth: () => {},
});
